//@ts-nocheck
import React, { useEffect, useRef } from 'react';
import { ModelConfig } from '../types/product';

interface ViewerProps {
    viewerConfig?: ModelConfig;
}

const Viewer = ({ viewerConfig }: ViewerProps) => {
    const SDKURL = process.env.REACT_APP_THREED_SDK_STAGING_URL as string;
    const viewerRef: React.RefObject<HTMLIFrameElement> = useRef(null);

    const handleOnload = () => {
        if (viewerConfig) {
            viewerRef?.current?.contentWindow?.postMessage(
                JSON.stringify({
                    requestId: 2,
                    command: 'initViewer',
                    config: viewerConfig
                }),
                SDKURL
            );
        }
    };

    const handleError = () => {};

    useEffect(() => {
        viewerRef?.current?.contentWindow?.postMessage(
            JSON.stringify({
                requestId: 2,
                command: 'Update',
                config: viewerConfig
            }),
            SDKURL
        );
    }, [viewerConfig]);

    return <iframe height="100%" width="100%" title="test" className=" bg-transparent" frameBorder="0" scrolling="no" onLoad={handleOnload} ref={viewerRef} src={SDKURL} onError={handleError} />;
};

export default React.memo(Viewer);
